app.config(function($routeProvider, $locationProvider) {
  $routeProvider
    .when('/', {
      template: '',
      controller: 'MainController'
    })
    .when('/adatok', {
      templateUrl: pc + '/personal-data/personal-data.template.html',
      controller: 'PersonalDataController'
    })
    .when('/osszesito', {
      templateUrl: pc + '/summary/summary.template.html',
      controller: 'SummaryController'
    })
    .when('/befejezes', {
      templateUrl: pc + '/final/final.template.html',
      controller: 'FinalController'
    })
    .otherwise('/')
  $locationProvider.html5Mode({
    enabled: false
  }).hashPrefix('')
})
